/*
  File: src/components/common/Loader.jsx
  Purpose: Reusable loading indicator with optional label.
  Usage: <Loader label="Loading products" />
*/
import React from 'react';

function Loader({ label }) {
    return (
        <div className="w-full flex items-center justify-center py-10">
            <div className="inline-flex items-center gap-3 text-white/80">
                <svg className="animate-spin h-5 w-5 text-white/70" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                </svg>
                <span className="text-sm">{label || 'Loading'}</span>
            </div>
        </div>
    );
}

export default Loader;


